import { useEffect, useState } from "react";
import { ViewComponents } from "./EventViewManagmentPanel";

export interface IChangeEventViewButton {
  defaultValue: boolean;
  defaultPath: string;
  activePath: string;
  defaultClass: string;
  activeClass: string;
  onChaneState: (newState: boolean, buttonName: ViewComponents) => void;
  buttonName: ViewComponents;
  currentGlobalValue: ViewComponents;
}
export const ChangeEventViewButton = ({
  defaultValue,
  defaultPath,
  defaultClass,
  activeClass,
  activePath,
  onChaneState,
  buttonName,
  currentGlobalValue,
}: IChangeEventViewButton) => {
  const onButtonClick = () => {
    const newState = !currentButtonState;
    setCurrentButtonState(newState);
    onChaneState(newState, buttonName);
  };

  const [currentButtonState, setCurrentButtonState] =
    useState<boolean>(defaultValue);

  useEffect(() => {
    if (currentGlobalValue !== buttonName) {
      console.log(`${buttonName} меняю на ` + false);
      setCurrentButtonState(false);
    }
  }, [currentGlobalValue]);
  console.log("Компонент " + defaultClass + " значение - " + defaultValue);

  return (
    <div onClick={onButtonClick} className="me-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="currentColor"
        className={"bi " + (defaultValue == true) ? activeClass : defaultClass}
        viewBox="0 0 16 16"
      >
        <path d={defaultValue == true ? activePath : defaultPath} />
      </svg>
    </div>
  );
};
